import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { HighlightedRate } from '@/share/HighlightedRate/HighlightedRate';
import { getFormattedNearRate, getFormattedRolloverPointsDisplayed, getFormattedRolloverRate, selectRfs } from '@/store/state/rfs/rfs.selectors';
import { selectCurrentLocale } from '@/store/state/ui/ui.selectors';

import { isDefined, isNotDefined } from '@sgme/fp';
import { Spinner } from '@/share/Spinner/Spinner';

export function RolloverRate() {
  const locale = useSelector(selectCurrentLocale);
  const rfs = useSelector(selectRfs);

  const rolloverRate = getFormattedRolloverRate(locale)(rfs);

  const nearRate = getFormattedNearRate(locale)(rfs);

  const rolloverPointsDisplay = getFormattedRolloverPointsDisplayed(locale)(rfs);

  const isRequesting = rfs.status === 'requesting' || rfs.status === 'starting-request';
  const status =
    isNotDefined(rolloverRate) && !isRequesting
      ? 'Idle' //
      : isRequesting //
        ? 'Waiting' //
        : 'Received';

  return (
    <>
      <div className="pt-5 form-group mb-0">
        <label>
          <FormattedMessage id="rollover.rolloverRate" />
        </label>
        <div data-e2e="rollover-rate">
          <FarPriceDisplay status={status} farPrice={rolloverRate} />
        </div>
      </div>
      <div className="pt-5 form-group mb-0">
        <FormattedMessage
          id={`rollover.rateExplaination${status !== 'Received' ? '.empty' : ''}`}
          values={{
            nearRate: nearRate && <HighlightedRate value={nearRate} />,
            rolloverPoints: (
              <span className="text-info" data-e2e="rollover-points">
                {rolloverPointsDisplay}
              </span>
            ),
          }}
        />
      </div>
    </>
  );
}

interface FarPriceDisplayProps {
  status: 'Idle' | 'Received' | 'Waiting';
  farPrice: string | undefined;
}

const FarPriceDisplay = ({ status, farPrice }: FarPriceDisplayProps) => {
  switch (status) {
    case 'Idle':
      return <IdleDisplay />;
    case 'Waiting':
      return <Spinner />;
    case 'Received':
      return isDefined(farPrice) ? (
        <div className="display-4 tabular-figures">
          <HighlightedRate value={farPrice} size={3} offset={1} />
        </div>
      ) : (
        <Spinner />
      );
  }
};

const IdleDisplay = () => <div className="display-4 tabular-figures">-</div>;
